import { render, staticRenderFns } from "./NewHomeView.vue?vue&type=template&id=552d7af4&"
import script from "./NewHomeView.vue?vue&type=script&lang=js&"
export * from "./NewHomeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports